/**
 * Bin Toss theme data, shared by the game and the leaderboard.
 *
 *   default_cat  → active bins, in display order
 *   cat_icons    → bin name → icon filename (falls back to all_icon_image)
 *   cat_items    → bin name → waste item image filenames
 *
 * Values may arrive as parsed JSON or as JSON strings, so everything is normalized here.
 */

import { ensureThemeJsonArray, getDvSourceImageUrl } from "./themeAssets";

function toObject(val) {
  if (val && typeof val === "object" && !Array.isArray(val)) return val;
  if (typeof val === "string" && val.trim()) {
    try {
      const parsed = JSON.parse(val);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) return parsed;
    } catch {
      /* not JSON */
    }
  }
  return {};
}

/** Active bins: [{ id, name, icon, hasOwnIcon }] — id is the 1-based position, as in the
 *  PHP game. hasOwnIcon is false when the bin falls back to the shared default icon. */
export function getBinTossBins(themeData) {
  const icons = toObject(themeData?.cat_icons);
  const fallbackIcon = String(themeData?.all_icon_image || "").trim();
  return ensureThemeJsonArray(themeData?.default_cat)
    .map((name) => String(name ?? "").trim())
    .filter(Boolean)
    .map((name, index) => {
      const ownIcon = String(icons[name] || "").trim();
      const icon = ownIcon || fallbackIcon;
      return {
        id: index + 1,
        name,
        icon: icon ? getDvSourceImageUrl(icon) : "",
        hasOwnIcon: Boolean(ownIcon),
      };
    });
}

/** Every item in the active bins: [{ id, url, bin }] where `bin` is the correct bin id. */
export function getBinTossItems(themeData) {
  const catItems = toObject(themeData?.cat_items);
  const items = [];
  getBinTossBins(themeData).forEach((bin) => {
    ensureThemeJsonArray(catItems[bin.name]).forEach((img) => {
      const file = String(img ?? "").trim();
      if (!file) return;
      items.push({ id: `item-${bin.id}-${items.length}`, url: getDvSourceImageUrl(file), bin: bin.id });
    });
  });
  return items;
}
